export default {"src":"/_next/static/media/logo-with-text-2.568a7116.svg","height":76,"width":437,"blurWidth":0,"blurHeight":0};